import { render } from "./MinhaConta.vue?vue&type=template&id=2526a3f0&scoped=true"
import script from "./MinhaConta.vue?vue&type=script&lang=js"
export * from "./MinhaConta.vue?vue&type=script&lang=js"

import "./MinhaConta.vue?vue&type=style&index=0&id=2526a3f0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\sensualle\\sensualle - pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2526a3f0"]])

export default __exports__